import { jsx as _jsx } from "react/jsx-runtime";
import { ConditionFieldDateRange } from './components/conditionFieldDateRange';
import { ConditionFieldDateSingle } from './components/conditionFieldDateSingle';
/**
 * Represents a component that can be used to visualize a date or a date range
 * filter
 */
export const ConditionFieldDate = (props) => {
    const { condition } = props;
    const isRange = condition.operator === 'between';
    if (isRange) {
        return _jsx(ConditionFieldDateRange, Object.assign({}, props));
    }
    return _jsx(ConditionFieldDateSingle, Object.assign({}, props));
};
